import dayjs from 'dayjs';

import { getRemainingOfferDuration } from 'shared/utils/getRemainingOfferDuration';
import { IUserProductIdOfferResponse } from 'productTemplate/types/UserProductIdOfferResponse';

export const getUserRemainingOfferDuration = ({
  offerStartTime,
  offerDuration,
}: Partial<IUserProductIdOfferResponse>) => {
  if (!offerStartTime || !offerDuration) return null;

  const offerStartTimeDayJs = offerStartTime && dayjs(offerStartTime);
  const { remainingOfferDuration } = getRemainingOfferDuration(offerStartTimeDayJs, offerDuration);

  return remainingOfferDuration;
};
